export const InfoMessage = ({ text }: { text: string }) => (
  <p className="subHeading text-accent py-1 text-center">{text}</p>
);
